import * as tslib_1 from "tslib";
import ThemeSwatch from './ThemeSwatch';
import { loadTheme } from 'owa-theme';
import { observer } from 'mobx-react';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';
import { getSupportedThemeIds } from 'owa-theme';
import * as React from 'react';
import { OptionDescription } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
var styles = require('./Theme.scss');
var ThemeFull = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeFull, _super);
    function ThemeFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeFull.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, strings.options_theme_description),
            React.createElement(FocusZone, { className: styles.fullSwatchContainer, direction: FocusZoneDirection.bidirectional, role: "listbox" }, getSupportedThemeIds().map(function (id) { return (React.createElement(ThemeSwatch, { themeId: id, key: id, onClick: _this.onThemeClick })); }))));
    };
    ThemeFull.prototype.onThemeClick = function (themeId) {
        loadTheme(themeId);
    };
    ThemeFull = tslib_1.__decorate([
        observer
    ], ThemeFull);
    return ThemeFull;
}(React.Component));
export default ThemeFull;
//# sourceMappingURL=ThemeFull.js.map